import EventCalendar from "../components/EventCalendar";
import { FaRegUserCircle,FaRegCheckCircle, FaBirthdayCake, FaUserFriends, FaStar, FaSwimmingPool, FaHandSparkles } from "react-icons/fa";
import { IoCalendarOutline, IoFastFoodOutline } from "react-icons/io5";
import { CiCalendar } from "react-icons/ci";
import { CgGym } from "react-icons/cg";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext";
import { useContext, useEffect, useRef, useState } from "react";
import { base_url } from '../url_variables';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { GridLoader } from "react-spinners";
import {TopBar} from '../components/topbar';
import { TostMessageContext } from "../context/TostMessage";
import { MenuContext } from "../context/MenuContext";
import ScrollToTop from "../ScrollToTop";
import { IoMdArrowRoundBack } from "react-icons/io";
import { PayPalButtons } from "@paypal/react-paypal-js";

export default function MakePayment() {
    const navigate = useNavigate();
    const {userProfile, logOutFunction} = useContext(UserContext);
    const [cookies] = useCookies();
    const [formFields, setFormFields] = useState({});
    const [apartmentList, setApartmentList] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const {state} = useLocation();
    const [pageData, setPageData] = useState({});
    const [initialised, setInitialised] = useState(false);
    const {setTostMessage} = useContext(TostMessageContext)
    const {menuOpen, setMenuOpen} = useContext(MenuContext)
    const [selectedServices, setSelectedServices] = useState([]);
    const [freeCancellation, includeFreeCancellation] = useState('no');

    useEffect(() => {
      if (menuOpen) setMenuOpen(false);
      setFormFields({...formFields, check_in: state?.check_in, check_out: state?.check_out });
      setInitialised(true); // flag
    }, [])

    const firstRender = useRef(true);

    useEffect(() => {
        if (!initialised) return;   // ❌ ignore all other updates
        if (!state?.selectedApartments) return;

        getData();                  // ✅ runs ONLY once
        setInitialised(false);      // stop it from ever running again
    }, [formFields, initialised]);

    async function getData() {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        console.log(state?.selectedApartments)
        // state?.selectedApartments.forEach((apartment, index) => {
        //     console.log(apartment)
        //     formData.append(`selected_apartments[]`, apartment);
        // })
        formData.append(`selected_apartments`, JSON.stringify(state?.selectedApartments));
        formData.append('cancellation', freeCancellation);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/make-payment.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setPageData({...pageData, ...response.data })
            } else {
                setTostMessage({
                    messageType: "error",
                    message: response.data.message,
                });
            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
          setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

    async function getDataChange(type) {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('cancellation', type);
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/make-payment.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            if (response.data.status) {
                setPageData({...pageData, ...response.data })
            } else {
                setTostMessage({
                    messageType: "error",
                    message: response.data.message,
                });
            }
            setPageLoading(false)
        } catch (error) {
          setPageLoading(false)
          setTostMessage({
                messageType: "error",
                message: 'Network error',
            });
        }
    }

    function addServices (service_id) {
        if (selectedServices?.includes(service_id)) {
            const new_arr = selectedServices.filter(item => item !== service_id);
            setSelectedServices(new_arr);
        } else {
            setSelectedServices([...selectedServices, service_id]);
        }
    }

    const makePayment = async (currency) => {
        const formData = new FormData();
        Object.entries(formFields).forEach(([key, value]) => {
          formData.append(key, value);
        });
        formData.append('booking_data', JSON.stringify(state?.selectedApartments));
        formData.append('currency', currency);
        formData.append('cancellation', freeCancellation);
        selectedServices.forEach(element => {
            formData.append('add_on_services[]', element);
        });
        setPageLoading(true)
        try {
            const response = await axios.post(base_url + '/reserve.php', formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: cookies?.userProfile?.session,
                    accountid: cookies?.userProfile?.main_id,
                },
            });
            if (response.data.code == 403) {
                logOutFunction()
            }
            setPageLoading(false)
            if (response.data.status) {
                window.open(response.data.payment_link, "_self");
                setTostMessage({
                    messageType: "success",
                    message: "Initiating payment...",
                });
            } else {
                setTostMessage({
                    messageType: "error",
                    message: response.data.message,
                });
            }
        } catch (error) {
          setPageLoading(false)
          setTostMessage({
                messageType: "error",
                message: "Network Error",
            });
        }
    }

    // useEffect(() => {
    //     if (firstRender.current) {
    //         firstRender.current = false;
    //         return; // skip the first run
    //     }

    //     getData()
    // }, [freeCancellation])

  return (
    <div className="flex flex-col rounded-[10px] min-h-full bg-white">
      <ScrollToTop />
      {pageLoading && (
      <div className="flex items-center justify-center h-full w-[-webkit-fill-available] z-[99] bg-[#ffffff] fixed opacity-[0.9]">
        <GridLoader
            color={'#037684'}
            loading={true}
            size={20}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
      </div>
      )}
        {/* <h2 className="text-2xl text-[#037684] font-bold mb-4">Welcome, {userProfile?.name}</h2> */}
        <TopBar title={`Welcome, ${cookies?.userProfile?.name}`} />
        <div className="animate-fadeIn py-6 px-10 flex flex-col justify-start">
            <div className="flex items-center justify-start gap-x-3">
                <button onClick={() => navigate(-1)} className="p-2 border border-2 rounded-full"><IoMdArrowRoundBack size={20} /></button>
                <h2 className="text-2xl text-black font-bold">{'Complete Booking'}</h2>
            </div>
                <div className="flex items-center justify-center gap-3 md:gap-10 mb-5 mt-5">
                    <div className="flex flex-col text-center items-center">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">1</div>
                    <p className="text-sm mt-1 text-black font-aileron-regular">{'SELECT APARTMENTS'}</p>
                    </div>
                
                    <div className="border-t border-gray-300 w-10 md:w-24"></div>
                
                    <div className="flex flex-col text-center items-center">
                    <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center">2</div>
                    <p className="text-sm mt-1 text-black font-aileron-regular">BOOKING DETAILS</p>
                    </div>
                
                    <div className="border-t border-gray-300 w-10 md:w-24"></div>
                
                    <div className="flex flex-col text-center items-center">
                    <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center">3</div>
                    <p className="text-sm mt-1 text-black font-aileron-regular">FINISH BOOKING</p>
                    </div>
                </div>
                {pageData?.clashing_date && 
                    <div className="w-[fit-content] mx-auto py-3 px-6 border border-1 rounded-[10px] bg-[#ff0000] text-center mb-4">
                        <p className="font-aileron-regular font-semibold text-[#ffffff]">Ooops! This unit is no longer available on your selected dates</p>
                    </div>
                }

                <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
                
                    <div className="lg:col-span-2 space-y-10">
                
                    <div>
                        <div className="flex items-start justify-between">
                        <div>
                            <p className="font-semibold font-aileron-regular">Your trip</p>
                            <p className="text-sm text-black mt-2">
                            <span className="font-semibold font-aileron-regular">Dates</span><br/>
                            {pageData?.booking_dates_summary}
                            </p>
                            <p className="text-sm text-black mt-4">
                            <span className="font-semibold font-aileron-regular">Duration</span><br/>
                            {pageData?.duration} Night(s)
                            </p>
                        </div>

                        </div>
                    </div>
                
                    <div>
                        <h2 className="text-md font-semibold font-aileron-regular">Main Guest Info</h2>
                        <p className="text-sm text-black mt-1">Guest name must match the valid ID used at check-in.</p>
                
                        <div className="grid sm:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="text-sm font-aileron-regular">First Name</label>
                            <input 
                            value={formFields?.first_name}
                            onChange={(e) => setFormFields({...formFields, first_name: e.target.value})}
                            className="first_name mt-1 w-full p-2 border rounded-lg" placeholder="Emmily" />
                        </div>
                
                        <div>
                            <label className="text-sm font-aileron-regular">Last Name</label>
                            <input 
                            value={formFields?.last_name}
                            onChange={(e) => setFormFields({...formFields, last_name: e.target.value})}
                            className="last_name mt-1 w-full p-2 border rounded-lg" placeholder="Morgan" />
                        </div>
                        </div>
                
                        <div className="grid sm:grid-cols-2 gap-4 mt-4">
                        <div>
                            <label className="text-sm font-aileron-regular">Email Address</label>
                            <input 
                            value={formFields?.email}
                            onChange={(e) => setFormFields({...formFields, email: e.target.value})}
                            className="email mt-1 w-full p-2 border rounded-lg" placeholder="email@example.com" />
                        </div>
                
                        <div>
                            <label className="text-sm font-aileron-regular">Phone Number</label>
                            <input 
                            value={formFields?.phone_number}
                            onChange={(e) => setFormFields({...formFields, phone_number: e.target.value})}
                            className="phone_number mt-1 w-full p-2 border rounded-lg" placeholder="(+234) 000 000 000" />
                        </div>
                        </div>
                        
                        <div className="flex flex-row gap-x-3 mt-4">
                            <input 
                            onChange={(e) => e.target.checked && setFormFields({ ...formFields, ...cookies?.userProfile?.defaults })}
                            className="booking_defaults" type="checkbox" name="booking_defaults" />
                            <label className="text-sm font-aileron-regular">Use booking defaults</label>
                        </div>
                    </div>
                
                    <div>
                        <h2 className="text-md  font-semiboldfont-aileron-regular">Special Requests <span className="text-black text-sm">(optional)</span></h2>
                        <p className="text-sm text-black mt-1">The property will do its best, but cannot guarantee to fulfil all requests.</p>
                
                        <textarea
                        name="special_requests"
                        value={formFields?.special_requests}
                        onChange={(e) => setFormFields({...formFields, special_requests: e.target.value})}
                        className="w-full mt-4 h-32 p-3 border rounded-lg"
                        placeholder="Let us know if there's anything we can assist you with."
                        ></textarea>
                    </div>
                
                    {pageData?.addons?.map((item, index) => {
                        return (
                            <div className="flex items-start justify-between border-t pt-6">
                                <div>
                                <p className="font-semibold font-aileron-regular">Add {item.service_name}?</p>
                                <p className="text-sm text-black">Yes, add for {item.price}</p>
                                </div>
                                <button onClick={() => addServices(item.service_id)} className="border-primary text-primary hover:bg-primary hover:text-white px-4 py-2 rounded-lg border text-sm">Add</button>
                            </div>
                        )
                    })}
                
                    </div>
                
                    <div className="sticky top-0 h-[min-content] animate-scaleIn">
                        <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
                    
                            <div className="border rounded-lg p-4 text-sm">
                            <div className="flex justify-between">
                                <div>
                                <p className="text-black font-semibold">Check-in</p>
                                <p className="font-aileron-regular">{state.check_in}</p>
                                </div>
                                <div>
                                <p className="text-black font-semibold">Check-out</p>
                                <p className="font-aileron-regular">{state.check_out}</p>
                                </div>
                            </div>
                            </div>
                    
                            <div className="text-sm space-y-2">
                            <div class="flex flex-col justify-between gap-y-1 mb-1">
                                <p class="mb-1">Your Selection</p>
                                <div class="flex flex-col">
                                    {state?.selectedApartments?.map((apartment, index) => 
                                        <p class="font-semibold font-aileron-regular text-md">{apartment?.quantity}{' '}{apartment?.apt_cat}</p>
                                    )}
                                </div>
                            </div>
                            <div className="flex flex-col justify-start addon_list">
                                {selectedServices?.map((service, index) => {
                                    return (
                                        <p key={index} className="font-aileron-regular mt-1">{pageData?.addons[pageData?.addons?.findIndex(item => item.service_id == service)].service_name}</p>
                                    )
                                })}
                            </div>
                            <p class="font-cormorant-semibold mb-1">Price Summary</p>
                            <div className="flex justify-between">
                                <p class="font-semibold font-aileron-regular text-md">Booking Amount</p>
                                <p className="font-semibold font-aileron-regular">{pageData?.booking_amount}</p>
                            </div>
                            <div className="flex justify-between">
                                <p class="font-semibold font-aileron-regular text-md">Taxes</p>
                                <p className="font-semibold font-aileron-regular">{pageData?.taxes}</p>
                            </div>
                            <div className="flex justify-between">
                                <p class="font-semibold font-aileron-regular text-md">Refundable Deposit</p>
                                <p className="font-semibold font-aileron-regular">{pageData?.refundable_deposit}</p>
                            </div>
                            {pageData?.cancellation_type == "checked" && <div className="flex justify-between">
                                    <p>Free cancellation fee</p>
                                    <p className="font-aileron-regular">{pageData?.cancellation_fee}</p>
                                </div>
                            }
                            </div>
                    
                            <div className="flex justify-between font-aileron-regular text-lg border-t pt-4">
                                <p className="font-bold">Total</p>
                                <p className="font-bold font-aileron-regular">{pageData?.total_amount}</p>
                            </div>
                        </div>
                        {/* <div className="flex flex-row gap-x-3 mt-4">
                            <input 
                            onChange={(e) => {includeFreeCancellation(e.target.checked ? 'checked' : 'no');getDataChange(e.target.checked ? 'checked' : 'no') }}
                            className="free_cancellation" type="checkbox" name="free_cancellation" />
                            <label className="text-sm font-aileron-regular">Include free cancellation</label>
                        </div> */}
                        <div className="pt-3">
                            {/* {freeCancellation == "checked" && <p className="font-aileron-regular font-semibold text-sm">
                            <span className="text-blue-600 font-aileron-regular text-[lg]">Free cancellation before {pageData?.max_cancellation_date}.</span>
                            </p>} */}
                            <button onClick={() => window.open('https://riverrunresidence.com/cancellation/', '_blank')} className="text-sm text-blue-600 mt-2">Read our cancellation policy</button>
                        </div>
                        <div className="flex flex-col items-center mt-5">
                                <button onClick={() => makePayment('NGN')} className="bg-primary text-black flex flex-row items-center justify-evenly w-full h-[50px] px-5 rounded-2xl shadow-md shrink-0 text-lg font-aileron-regular">
                                    <span className="text-white font-aileron-regular text-lg">Pay NGN</span>
                                </button>
                                <span className="text-black font-aileron-regular text-sm my-2">or</span>
                                {/* <button onClick={() => makePayment('USD')} className="bg-primary text-black flex flex-row items-center justify-evenly w-full h-[50px] px-5 rounded-2xl shadow-md shrink-0 text-lg font-aileron-regular">
                                    <span className="text-white font-aileron-regular text-lg">Pay USD</span>
                                </button> */}
                                <PayPalButtons
                                    style={{ layout: "vertical", color: "gold", shape: "pill" }}
                                    createOrder={(data, actions) => {
                                    return fetch(base_url + "/reserve-paypal.php", {
                                        method: "POST",
                                        headers: {
                                            token: cookies?.userProfile?.session,
                                            accountid: cookies?.userProfile?.main_id,
                                        },
                                        body: JSON.stringify({
                                            check_in: formFields?.check_in,
                                            check_out: formFields?.check_out,
                                            apt: formFields?.apt,
                                            currency: 'USD',
                                            first_name: formFields?.first_name,
                                            last_name: formFields?.last_name,
                                            email: formFields?.email,
                                            phone_number: formFields?.phone_number,
                                            special_requests: formFields?.special_requests,
                                            cancellation: freeCancellation,
                                            add_on_services: selectedServices,
                                            booking_data: state?.selectedApartments
                                        })
                                    })
                                    .then(res => res.json())
                                    .then(order => order.orderID);
                                    }}
                                    onApprove={(data, actions) => {
                                    return fetch(`${base_url}/reserve-capture-paypal.php?orderID=${data.orderID}`, {
                                        method: "POST",
                                        headers: {
                                            token: cookies?.userProfile?.session,
                                            accountid: cookies?.userProfile?.main_id,
                                        },
                                    })
                                        .then(res => res.json())
                                        .then(details => {
                                        if (details.status) {
                                            window.open(details.redirect_url, "_self");
                                            setTostMessage({
                                                messageType: "success",
                                                message: "Payment completed",
                                            });
                                            // alert("Payment completed by " + details.payer.name.given_name);
                                        } else {
                                            setTostMessage({
                                                messageType: 'error',
                                                message: 'Could not complete payment'
                                            })
                                        }
                                        });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
        </div>
    </div>
  );
}
